export const SET_THEME = 'CUSTOM/SET_THEME'
export const UPDATE_DASHBOARD = 'CUSTOM/DASHBOARD_UPDATE'
export const FETCH_ERROR = 'RA/FETCH_ERROR'
export const SHOW_API_ERROR_MODAL = 'CUSTOM/SHOW_API_ERROR_MODAL'
export const HIDE_API_ERROR_MODAL = 'CUSTOM/HIDE_API_ERROR_MODAL'
